let isRoamingActive = false;
let currentIndex = 0;
let eventHandler = null; // 保存当前事件监听函数

/**
 * 
 * @param {*} cameraPositionList 
 * @param {*} speed 
 * @param {*} item 携带的数据组，可以是任意数据，在回调函数中会返回
 * @param {*} cb 当前动画组运行结束回调
 * @param {*} itemRunCb 每次运行结束回调
 * @returns 
 */
export const roamingPlay = (cameraPositionList, speed, item, cb, itemRunCb = null) => {
  if (isRoamingActive || !cameraPositionList?.length) return;
  isRoamingActive = true;
  currentIndex = 0;
  const averageSpeed = Math.ceil(speed / cameraPositionList.length);

  // 清理旧监听器
  if (eventHandler) {
    document.removeEventListener('RELocateCam', eventHandler);
  }

  // 立即执行第一个视角
  const firstItem = JSON.parse(cameraPositionList[0]);
  window.BlackHole3D.Camera.setCamLocateTo(firstItem, 0, 0);

  // 定义唯一事件处理器
  eventHandler = () => {
    executeNextStep(cameraPositionList, averageSpeed, item, cb, itemRunCb);
  };

  // 绑定监听
  document.addEventListener('RELocateCam', eventHandler);
};

const executeNextStep = (cameraPositionList, speed, items, cb, itemRunCb) => {
  if (!isRoamingActive || currentIndex >= cameraPositionList.length - 1) {
    stopRoaming();
    cb(items, currentIndex)
    return;
  }
  currentIndex++;
  const item = cameraPositionList[currentIndex];
  const itemInfo = JSON.parse(item);
  itemRunCb && itemRunCb(itemInfo)
  // 触发下一个视角动画
  window.BlackHole3D.Camera.setCamLocateTo(itemInfo, 0, -speed);
};
// 停止漫游
export const roamingStop = (list) => {
  if (list && list.length) {
    window.BlackHole3D.Camera.setCamLocateTo(JSON.parse(list[0]), 0, 0);
    stopRoaming();
  }
};

//暂停漫游
export const roamingPause = () => {
  isRoamingActive = false;
  const roamingPauseIndex = currentIndex;
  // 移除事件监听
  if (eventHandler) {
    document.removeEventListener('RELocateCam', eventHandler);
    eventHandler = null;
  }
  return roamingPauseIndex
};

const stopRoaming = () => {
  isRoamingActive = false;
  currentIndex = 0;
  // 移除事件监听
  if (eventHandler) {
    document.removeEventListener('RELocateCam', eventHandler);
    eventHandler = null;
  }
};